module.exports = __webpack_public_path__ + "cf7f05431fed51de3eaaf36e62e0ae4f.svg";